// extracted by mini-css-extract-plugin
module.exports =  {"select":"---src-components-Shared-VPMultiselect__select--cVVRs"};